const SUPPORTED_LOGO_FILE_INPUT_TYPES = '.jpg,.jpeg,.png'
const SUPPORTED_IMAGE_FILE_SCHEMA_TYPES = ['image/jpeg', 'image/png']

export default {
  SUPPORTED_LOGO_FILE_INPUT_TYPES,
  SUPPORTED_IMAGE_FILE_SCHEMA_TYPES,
}
